import React from 'react'
import { connect } from 'react-redux'
import find from 'lodash/find'

import {
    selectPaymentOption
} from './paymentMethodActionCreators'

import {
    OptionListItemRadio,
    CheckoutSection,
    hiddenAnchorStyle
} from '../../components'

import { Fade } from '../../componentAnimations'
import { translateResourceString } from '../../../util/translationUtility';
import { CheckoutCompleteContainer } from '../PlaceOrder'

const getById = (methods, id) => {
    return methods.filter(pm => pm.Id === id)[0];
}

class CheckoutPayment extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isCollapsed: false };
        this.onItemSelected = this.onItemSelected.bind(this);
        this.onClickChange = this.onClickChange.bind(this);
        this.onPaymentIsValid = this.onPaymentIsValid.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
    }

    onPaymentIsValid() {
        this.setState({ isCollapsed: true });
    }

    onItemSelected(id) {
        const paymentOption = getById(this.props.paymentOptions, id);
        if (!paymentOption) {
            console.error(`No payment method with id '${id}'`);
            return;
        }
        if (!paymentOption.paymentOptionComponent) {
            this.setState({ isCollapsed: true });
        }
        this.props.onSelected(id, paymentOption.Name);
    }

    onClickChange(e) {
        e.preventDefault();
        this.setState({ isCollapsed: !this.state.isCollapsed });
        this.props.onCancel();
    }

    onCancelClick(e) {
        this.setState({ isCollapsed: false });
        this.props.onCancel();
    }

    render() {
        if(!!!this.props.show) {
            return <React.Fragment />
        }

        const items = this.props.paymentOptions.map(pm => {
            let selected = pm.Id === this.props.selectedPaymentOptionId;
            const visible = !this.props.selectedPaymentOptionId || selected;
            if (pm.paymentOptionComponent) {
                const PaymentOptionComponent = pm.paymentOptionComponent;
                return (
                    <OptionListItemRadio
                        key={pm.Id}
                        id={pm.Id}
                        isSelected={selected}
                        onClick={this.onItemSelected}
                        label={pm.Name}
                        hidden={!visible}>
                        <div className={selected ? "mt-2" : ""}>
                            <PaymentOptionComponent
                                isSelected={selected}
                                onPaymentIsValid={this.onPaymentIsValid}
                                onPaymentCancel={this.props.onCancel}
                            />
                        </div>
                    </OptionListItemRadio>
                )
            } else {
                return (<OptionListItemRadio
                    key={pm.Id}
                    id={pm.Id}
                    isSelected={selected}
                    onClick={this.onItemSelected}
                    label={pm.Name}
                    hidden={!visible} />)
            }
        });
        const canChange = true;
        return (
            <CheckoutSection label={"Payment Information"} hidden={false}>
                <div className='checkout-payment-wrapper bg-grey-light'>
                    <div className='d-flex justify-content-between pt-2 px-2'>
                        <div className="fw-600">
                            <i className="fas fa-lock pr-1"></i>
                            {translateResourceString("/Checkout/PaymentInformation/SecurePayment")}
                        </div>

                        {
                         this.props.selectedPaymentOptionId  &&
                         <div
                                className="link-base"
                                style={{cursor: 'pointer'}}
                                onClick={this.onCancelClick}>
                                <span>{translateResourceString("/Checkout/PaymentInformation/CancelButton")}</span>
                          </div>
                        }
                    </div>
                    <Fade inProp={!this.state.isCollapsed}>
                        {!items || items.length === 0 &&
                         <div className='p-2'>No payment method available </div>
                        }

                        <div style={{ display: this.state.isCollapsed ? 'none' : 'inherit' }}>
                            {items}
                        </div>
                        {this.props.selectedPaymentOptionId &&<CheckoutCompleteContainer/>}
                    </Fade>
                </div>

            </CheckoutSection>
        );
    }
}

const formatPayment = ({ constants, entities }) => {

    const formatPaypalPayloadDetailsForSummary = (det) => {
        if (det) {
            if (typeof (det.firstName) !== 'undefined' && typeof (det.lastName) !== 'undefined' && typeof (det.email) !== 'undefined') {
                return `${det.firstName.length > 0 ? det.firstName + " " : ""}${det.lastName.length > 0 ? det.lastName + " " : ""} (${det.email})`;
            } else if (typeof (det.email) !== 'undefined' && det.email.length > 0) {
                return det.email;
            }
        }
        return "unspecified";
    }

    let formatters = [
        {
            Id: constants.purchaseOrderPaymentId,
            format: ({ POValue }) =>
                (`Purchase Order ${((POValue && POValue.length > 0) ? " #: " : "")}${POValue || ""}`)
        },
        {
            Id: constants.braintreeSettings.braintreePaymentId,
            format: ({ BraintreePaymentPayload }) => {
                if (!BraintreePaymentPayload) {
                    return "Pending";
                } else {
                    if (BraintreePaymentPayload.type === "PayPalAccount") {
                        return `Paypal: ${formatPaypalPayloadDetailsForSummary(BraintreePaymentPayload.details)}`;
                    } else if (BraintreePaymentPayload.type === "CreditCard") {
                        return `Card: ${BraintreePaymentPayload.description}`
                    } else {
                        return "Unknown payment method";
                    }

                }
            }
        },
        {
            Id: constants.eBizChargePaymentMethodId,
            format: () => translateResourceString("/Checkout/PaymentInformation/CreditCard")
        }
    ];
    const formatter = find(formatters, x => x.Id === entities.SelectedPaymentOptionId);
    if (formatter) {
        return formatter.format(entities.PaymentRecord);
    }
}

const mapCheckoutPaymentStateToProps = (state) => {
    var allowPurchaseOrder = state.entities.Summary.SubTotal >= state.constants.minimumCartValueForPO;
    var checkIsStopWorkShop = state.entities.CartItems.some(item => item.IsStopWorkshop);
    return {
        paymentOptions: state.entities.PaymentOptions.filter(po => po.Name !== "Purchase Order" || (allowPurchaseOrder && !checkIsStopWorkShop)),
        selectedPaymentOptionId: state.entities.SelectedPaymentOptionId,
        selectedDisplay: formatPayment(state),
        show: state.ui.onPaymentScreen
    }
}

const mapCheckoutPaymentDispatchToProps = (dispatch) => {
    return {
        onSelected: (id, displayName) => dispatch(selectPaymentOption(id, displayName)),
        onCancel: () => dispatch(selectPaymentOption(''))
    }
}

const CheckoutPaymentContainer = connect(
    mapCheckoutPaymentStateToProps,
    mapCheckoutPaymentDispatchToProps
)(CheckoutPayment);


export default CheckoutPaymentContainer
